<hard-modal
  [title]="title | hardTranslate"
  [isMoving]="false"
  [icon]="titleIcon"
  [actions]="actions"
  (closeModal)="close()"
>
  @if (messageIcon?.length > 0) {
    <div
      class="flex justify-center items-center text-5xl p-2"
      [class]="messageIcon"
    ></div>
  }
  <div
    class="message"
    [innerHTML]="message | hardTranslate"
  ></div>
</hard-modal>

<ng-template #actions>
  <hard-button
    (click)="close()"
    data-id="cancelButton"
  >
    <span
      [ngClass]="btnCloseIcon"
      class="mr-3"
    ></span>
    <span>{{ btnCloseText | hardTranslate }}</span>
  </hard-button>

  <hard-button
    [type]="btnType"
    (click)="close(true)"
    data-id="actionButton"
  >
    <span
      class="mr-3"
      [ngClass]="btnIcon"
    ></span>
    <span>{{ btnText | hardTranslate }}</span>
  </hard-button>
</ng-template>
